import { render, staticRenderFns } from "./SliderImage.vue?vue&type=template&id=874afda2&scoped=true"
import script from "./SliderImage.vue?vue&type=script&lang=js"
export * from "./SliderImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874afda2",
  null
  
)

export default component.exports